import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
import { getCurrentBranchGuid } from '../../helpers/storage';
// utilities
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature sequences
import * as A from './actions';
//////////////////////////////////////////////////

export const initialState = {
  transformers: [],
  sequencesList: [],
  currentSequence: {},
  dateFormatOptions: [],
  dateFormatPatterns: {},
};

const getSequencesListSuccess = (state, data) => {
  const currentBranchGuid = getCurrentBranchGuid();

  const mappedList = R.map((item) => {
    const elementBranchGuid = G.getBranchGuidFromObject(item);

    return R.mergeRight(item, {
      disabled: G.notEquals(currentBranchGuid, elementBranchGuid),
      [GC.FIELD_BRANCH_NAME]: G.getBranchNameFromWindowByGuid(elementBranchGuid),
    });
  }, R.or(data, []));

  return P.$set('sequencesList', mappedList, state);
};

const getSequenceSuccess = (state, data) => (
  P.$set('currentSequence', data, state)
);

const getSequenceTransformersSuccess = (state, data) => (
  P.$set('transformers', data, state)
);

const getSequenceDateFormatPatternsSuccess = (state, data) => {
  const dateFormatPatterns = R.defaultTo({}, data);

  const dateFormatOptions = R.compose(
    G.addEmptyOptionToDropDown,
    R.values,
    R.mapObjIndexed((label, value) => ({ label, value })),
  )(dateFormatPatterns);

  return R.mergeRight(state, { dateFormatOptions, dateFormatPatterns });
};

const createNewSequenceSuccess = (state, data) => P.$add('sequencesList', data, state);

const updateSequenceSuccess = (state, data) => {
  const { sequencesList } = state;

  const index = R.findIndex(R.propEq(G.getGuidFromObject(data), GC.FIELD_GUID), sequencesList);

  return P.$set(`sequencesList.${index}`, data, state);
};

const deleteSequenceSuccess = (state, guid) => {
  const { sequencesList } = state;

  const index = R.findIndex(R.propEq(guid, GC.FIELD_GUID), sequencesList);

  return P.$drop(`sequencesList.${index}`, state);
};

export default createReducer({
  [A.getSequenceSuccess]: getSequenceSuccess,
  [A.updateSequenceSuccess]: updateSequenceSuccess,
  [A.deleteSequenceSuccess]: deleteSequenceSuccess,
  [A.getSequencesListSuccess]: getSequencesListSuccess,
  [A.createNewSequenceSuccess]: createNewSequenceSuccess,
  [A.getSequenceTransformersSuccess]: getSequenceTransformersSuccess,
  [A.getSequenceDateFormatPatternsSuccess]: getSequenceDateFormatPatternsSuccess,
}, initialState);
